import { FC } from "react";
import { useTranslation } from 'next-i18next';
import styled from '@emotion/styled';
import { mediaQueries } from '@digando/react-component-library';
import { DrawerStep } from '../../sidebar/interfaces/drawer.interfaces';
import { useAuthContext } from '../../../store/auth.context';

export const CardLoginHint: FC = () => {
  const [t] = useTranslation(['search']);
  const { setSignInStep, setIsSignInVisible } = useAuthContext();

  return (
    <LoginHintWrapper>
      <div>
        {t('search:login-hint')}
        <button onClick={(): void => {
          setSignInStep(DrawerStep.SIGN_IN);
          setIsSignInVisible(true);
        }}>
          {t('search:login-hint-link-text')}
        </button>
      </div>
    </LoginHintWrapper>
  );
};


const LoginHintWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media ${mediaQueries.tablet} {
    div {
      flex-direction: row;
      gap: 5px;
    }
  }

  @media ${mediaQueries.laptopL} {
    div {
      display: inline-block;
    }
  }

  button {
    display: inline;
    background-color: transparent;
    border: none;
    padding: 0;
    margin: 0;
    color: var(--primary-color);
    cursor: pointer;
  }
`;
